import { WSPage, WSPageToolbar } from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";
import React, { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { RequirementDetailsContent } from "../../../../Requirements/components/RequirementsDetails/RequirementDetailsContent";
import { RequirementContextType } from "../../../../Requirements/types";
import { useRequirementsConfig } from "../../../../Requirements/useRequirementsConfig";

type RequirementsDetailsProps = {
  requirement: IRequirementResponse;
};

export const RouteOnboardingRequirementDetailsContent: React.FC<
  RequirementsDetailsProps
> = ({ requirement }) => {
  const history = useHistory();
  const goBack = useCallback(() => {
    history.replace("/member/onboarding/payee/requirements");
  }, [history]);

  const requirementConfig = useRequirementsConfig({
    requirements: [requirement],
    contextType: RequirementContextType.Payer
  });

  const headerActions =
    requirementConfig.getOnboardingToolbarActions(requirement)?.(goBack) || [];

  const title = requirementConfig.getRequirementName(requirement);

  const handleDocumentKeyUp = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        goBack();
      }
    },
    [goBack]
  );

  useEffect(() => {
    document.addEventListener("keyup", handleDocumentKeyUp);
    return () => {
      document.removeEventListener("keyup", handleDocumentKeyUp);
    };
  }, [handleDocumentKeyUp]);

  return (
    <WSPage>
      <WSPageToolbar title={title} actions={headerActions} />

      <RequirementDetailsContent
        {...requirementConfig}
        key={requirementConfig.dataUpdatedAt}
        contextType={RequirementContextType.Payer}
        requirement={requirement}
        showTitle={false}
      />
    </WSPage>
  );
};
